<div *ngIf="!editMode && selectedSkillLevel">
  <span *ngIf="selectedSkillLevel.rank == 0">N/A</span>
  <div *ngIf="selectedSkillLevel.rank != 0" class="readonly-skills" [matTooltip]="getTooltipValue(selectedSkillLevel)">
    <div
      *ngFor="let i of [1, 2, 3, 4, 5]"
      class="level readonly"
      [class.highlighted]="selectedSkillLevel.rank >= i"
    ></div>
  </div>
</div>
<div *ngIf="editMode && skillLevels.length" class="editable-skills-container">
  <div
    class="editable-skills"
    [class.error]="hasError"
    (mouseleave)="onMouseLeave()"
    attr.aria-labelledby="{{ ariaLabelledby }}"
  >
    <div
      [attr.aria-label]="getValue(skillLevel)"
      *ngFor="let skillLevel of skillLevels; let i = index"
      (mouseenter)="onMouseHover(skillLevel)"
      (click)="onClick(skillLevel)"
      (keydown)="keyDown($event, i)"
      id="{{ skillLevel.id }}"
      class="level edit-mode"
      [class.na]="skillLevel.rank == 0"
      [class.highlighted]="hoveredSkillLevel && hoveredSkillLevel.rank >= i && i != 0"
      [class.selected]="
        selectedSkillLevel &&
        selectedSkillLevel.rank >= i &&
        (!hoveredSkillLevel || hoveredSkillLevel.rank >= i) &&
        i != 0
      "
      [class.selected-na]="selectedSkillLevel && selectedSkillLevel.rank == 0 && i == 0"
      tabindex="0"
    >
      {{ skillLevel.rank == 0 ? 'N/A' : '' }}
    </div>
    <button
      *ngIf="selectedSkillLevel"
      mat-flat-button
      class="skill-delete-button"
      (click)="onDeleteSkill()"
      matTooltip="Delete skill value"
      aria-label="Delete skill value"
    >
      <mat-icon>delete</mat-icon>
    </button>
  </div>
  <p class="skill-desc" *ngIf="hoveredSkillLevel && hoveredSkillLevel.rank != 0">{{ getValue(hoveredSkillLevel) }}</p>
  <p class="skill-desc" *ngIf="!hoveredSkillLevel && selectedSkillLevel && selectedSkillLevel.rank != 0">
    {{ getValue(selectedSkillLevel) }}
  </p>
  <mat-error class="mat-error-skill" [class.error]="hasError">{{ errorMessage }}</mat-error>
</div>
